import { render, staticRenderFns } from "./ProductAd.vue?vue&type=template&id=f760852a&"
import script from "./ProductAd.vue?vue&type=script&lang=js&"
export * from "./ProductAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports